
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/EarnCrazyPoints",
      function () {
        return require("private-next-pages/article/EarnCrazyPoints.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/EarnCrazyPoints"])
      });
    }
  